import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  toggleResponseStatus,
  updateResponse,
  deleteResponse,
  saveResponse
} from "actions";
import { closeModalAction } from "actions/modal";
import { setPage } from "actions/router";
import { deleteSchedule } from "components/Pages/Settings/SettingsSchedules/actions";
import Immutable from "immutable";
import Checkbox from "components/Common/Checkbox";
import Tag from "components/Common/Tag";
import Button from "components/Common/Button";
import classNames from "classnames";
import ResponseStatus from "components/Common/ResponseStatus";
import { setDropdownVariable } from "actions/variables";
import PropTypes from "prop-types";
import ImmutablePropTypes from "react-immutable-proptypes";
import { setCookie } from "services/cookies";
import colors from "stylesheets/utilities/colors.scss";
import "./style.scss";

const blockName = "ModalWarning";

export class ModalWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checked: false,
      scrolledToBottom: false
    };

    this.buttonsTypes = {
      "cancel": {
        text: "Cancel",
        tint: colors.black
      },
      "delete": {
        text: "Delete",
        tint: colors.colorUIBad
      },
      "delete_schedule": {
        text: "Delete Schedule",
        tint: colors.colorUIBad
      },
      "delete-variable": {
        text: "Delete Variable",
        tint: colors.colorUIBad
      },
      "delete_training": {
        text: "Delete",
        tint: colors.colorUIBad
      },
      "save-turn-off": {
        text: "Save Changes & Hide",
        tint: colors.colorUIPrimary
      },
      "turn-off-changes": {
        text: "Hide Without Changes",
        tint: colors.colorUIPrimary
      },
      "turn-off": {
        text: "Hide",
        tint: colors.colorUIPrimary
      },
      "save-turn-on": {
        text: "Save Changes & Make Live",
        tint: colors.colorUIPrimary
      },
      "turn-on-changes": {
        text: "Make Live Without Changes",
        tint: colors.colorBlack
      },
      "turn-on": {
        text: "Make Live",
        tint: colors.colorUIPrimary
      }
    };

    this.handleCheckboxToggle = this.handleCheckboxToggle.bind(this);
  }

  /**
   * @param {String} responseId
   * @param {Number} messageIndex
   */
  handleScheduleReferenceButtonClick(responseId, messageIndex) {
    this.props.closeModal();
    this.props.setPage(
      `/answers/${responseId}?language=en&messageIndex=${messageIndex}`,
      "add",
      "Schedules"
    );
  }

  /**
   * Link to Answer containing fallback or quick reply references
   * @param {unknown} currentResponse
   * @param {unknown} newResponse
   * @param {String} language
   * @param {Number} messageIndex
   */
  handleReferenceButtonClick(
    currentResponse,
    newResponse,
    language,
    messageIndex
  ) {
    this.props.closeModal();
    this.props.setPage(
      `/answers/${newResponse.id}${language ? `?language=${language}` : ""}${
        typeof messageIndex === "number" ? `&messageIndex=${messageIndex}` : ""
      }${this.props.type === "quickReply" ? "&qr=1" : ""}`,
      "add",
      currentResponse.handle
    );
  }

  /**
   * Determine if we have scrolledToBottom (needed for list gradient)
   * @param {Object} event
   */
  handleScroll(event) {
    this.setState({
      scrolledToBottom: (
        event.target.scrollTop >=
        event.target.scrollHeight - event.target.offsetHeight
      )
    });
  }

  /**
   * Handle button click action
   * @param {String} type Button type
   */
  handleButtonClick(type) {
    const { resolve } = this.props;

    switch (type) {
      case "delete":
        this.props.deleteResponse(this.props.response);
        break;
      case "delete_schedule":
        this.props.deleteSchedule({ scheduleId: this.props.scheduleId });
        break;

      case "delete-variable": {
        const {
          setDropdownVariableAction,
          variable,
          newVariable,
          responseId,
          messageIndex,
          keyPath,
          variableListIndex
        } = this.props;
        setDropdownVariableAction({
          variable,
          newVariable,
          responseId,
          messageIndex,
          keyPath,
          variableListIndex
        });
        break;
      }

      case "delete_training": {
        const {
          deleteTraining, expression, expressionPairIndex, expressionIndex
        } = this.props;
        deleteTraining(expression, expressionPairIndex, expressionIndex);
      }

        break;

      case "turn-off":
      case "turn-on":
      case "turn-off-changes":
      case "turn-on-changes":
        this.props.toggleResponseStatus(
          this.props.response,
          !this.props.response.get("live")
        );

        if (this.state.checked) {
          setCookie("rememberUnsavedChoice", "toggle");
        }

        break;
      case "save-turn-on":
      case "save-turn-off":
        // Set Live to "true" in responses reducer
        this.props.updateResponse(this.props.response.id, { live: !this.props.response.get("live") });
        // Save the response (with the updated live state)
        this.props.saveResponse(this.props.response);

        if (this.state.checked) {
          setCookie("rememberUnsavedChoice", "save");
        }

        break;
      default: break;
    }

    this.props.closeModal();

    if (typeof resolve === "function") {
      resolve(type);
    }
  }

  /**
   * Toggle checkbox state
   */
  handleCheckboxToggle() {
    const { checked } = this.props;

    this.setState({ checked: !checked });
  }

  /**
   * Render the reference buttons
   * @param {Object} response Response
   * @param {List} tags Tags
   * @param {Number} index Message Index
   * @param {Array.<Object>} languages Array of languages for each Answer
   * @returns {ReactElement}
   */
  renderResponsePreview(response, tags, index, languages) {
    return (
      <div key={index} className="ModalWarning__reference-buttons">
        {languages.map((item) => {
          const itemIsObject = typeof item === "object";
          const language = itemIsObject ? item.language : item;

          return (
            <button
              type="button"
              className="ModalWarning__reference-buttons__reference-button"
              key={language}
              onClick={() => {
                this.handleReferenceButtonClick(
                  this.props.response,
                  response,
                  language,
                  itemIsObject && item.index
                );
              }}
            >
              <div className="ModalWarning__reference-buttons__reference-button__info-group">
                <h5 className="ModalWarning__reference-buttons__reference-button__info-group__title">
                  {response.get("handle")}
                </h5>
                <div className="ModalWarning__reference-buttons__reference-button__info-group__status">
                  <ResponseStatus isSmall isOn={response.get("live")} />
                </div>
                <h6 className="ModalWarning__reference-buttons__reference-button__info-group__language">
                  {language}
                </h6>
              </div>
              {response.get("tags").size > 0 && (
                <div className="ModalWarning__reference-buttons__reference-button__tag-group">
                  {response.get("tags").map(
                    tagID => (
                      <Tag
                        key={tagID}
                        customClassName="ModalWarning__reference-buttons__reference-button__tag-group__tag"
                        tag={tags.find(tag => tag.id === tagID)}
                        showAsLine
                      />
                    )
                  )}
                </div>
              )}
            </button>
          );
        })}
      </div>
    );
  }

  /**
   *
   * @param {Object} response
   * @param {Number} messageIndex
   * @returns {ReactElement}
   */
  renderSimpleResponsePreview(response, messageIndex) {
    return (
      <div className="ModalWarning__reference-buttons">
        <button
          type="button"
          className="ModalWarning__reference-buttons__reference-button"
          onClick={() => {
            this.handleScheduleReferenceButtonClick(
              response.id,
              messageIndex
            );
          }}
        >
          <div className="ModalWarning__reference-buttons__reference-button__info-group">
            <h5 className="ModalWarning__reference-buttons__reference-button__info-group__title">
              {response.handle}
            </h5>
            <div className="ModalWarning__reference-buttons__reference-button__info-group__status">
              <ResponseStatus isSmall isOn={response.live} />
            </div>
          </div>
        </button>
      </div>
    );
  }

  /**
   * Handle rendering either quick reply or fallback references
   * @param {Boolean} hasFallbackReferences
   * @param {Boolean} hasQuickReplyReferences
   * @param {Boolean} hasRedirectReferences
   * @returns {ReactElement|null}
   */
  renderReferences(hasFallbackReferences, hasQuickReplyReferences, hasRedirectReferences) {
    const {
      responseFallbackReferenceResponses,
      responseFallbackReferences,
      responseQuickReplyReferenceResponses,
      responseQuickReplyReferences,
      responseAnswersRedirectReferencesResponses,
      responseAnswersRedirectReferences,
      tags
    } = this.props;

    if (hasFallbackReferences) {
      return (
        <section>
          {responseFallbackReferenceResponses.map(
            (response, i) => {
              const languageList = responseFallbackReferences[
                response.id
              ].languages.map(item => item);

              return this.renderResponsePreview(
                response,
                tags,
                i,
                languageList
              );
            }
          )}
        </section>
      );
    }

    if (hasQuickReplyReferences) {
      return (
        <section>
          {responseQuickReplyReferenceResponses.map(
            (response, i) => (
              this.renderResponsePreview(
                response,
                tags,
                i,
                responseQuickReplyReferences[response.id].languages
              )
            )
          )}
        </section>
      );
    }

    if (hasRedirectReferences) {
      return (
        <section>
          {responseAnswersRedirectReferencesResponses.map(
            (response, i) => (
              this.renderResponsePreview(
                response,
                tags,
                i,
                responseAnswersRedirectReferences[response.id].languages
              )
            )
          )}
        </section>
      );
    }

    return null;
  }

  /**
   *
   * @returns {HTMLElement}
   */
  renderScheduleReferences() {
    const { responseScheduleReferences, scheduleName } = this.props;

    // Get the index references of the schedule in the responses
    const messageReferenceIndices = responseScheduleReferences.map(
      response => response.messages.en.findIndex(message => message.scheduleName === scheduleName)
    );

    return (
      <section>
        {responseScheduleReferences.map(
          (response, i) => this.renderSimpleResponsePreview(
            response, messageReferenceIndices.get(i)
          )
        )}
      </section>
    );
  }

  /**
   * Render the WarningModal action buttons
   */
  renderActionButtons() {
    const { buttons, actions } = this.props;

    if (buttons) {
      return buttons.map((button, i) => (
        <Button
          key={button}
          customClassName="ModalWarning__button-group__button"
          onClick={() => this.handleButtonClick(button)}
          text={this.buttonsTypes[button].text}
          title={this.buttonsTypes[button].text}
          tint={i === 0 ? this.buttonsTypes[button].tint : colors.colorBlack}
          light
        />
      ));
    }

    if (actions) {
      return actions.map(action => (
        <Button
          key={action.title}
          customClassName={classNames(`${blockName}__button-group__button`, {
            [`${blockName}__button-group__button--red`]: action.buttonTint === "alert",
            [`${blockName}__button-group__button--blue`]: action.buttonTint === "primary"
          })}
          onClick={action.onClick}
          text={action.title}
          title={action.title}
          light
        />
      ));
    }

    return null;
  }

  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      subTitle,
      responseFallbackReferenceResponses,
      responseQuickReplyReferenceResponses,
      responseScheduleReferences,
      responseAnswersRedirectReferencesResponses
    } = this.props;
    const hasFallbackReferences = Boolean(responseFallbackReferenceResponses.size);
    const hasQuickReplyReferences = Boolean(responseQuickReplyReferenceResponses.size);
    const hasRedirectReferences = Boolean(responseAnswersRedirectReferencesResponses.size);
    const hasResponseScheduleReferences = Boolean(responseScheduleReferences &&
      responseScheduleReferences.size);

    const shouldRenderReferences = hasFallbackReferences ||
      hasQuickReplyReferences ||
      hasRedirectReferences ||
      hasResponseScheduleReferences;

    const maxNumberOfReferenceButtons = 3;

    return (
      <div className="Modal__modal Modal__modal--small">
        <label className="Modal__title Modal__title--small">
          {this.props.title}
        </label>
        <section className="ModalWarning__section">
          {Boolean(subTitle) && (
            <h1 className={`${blockName}__sub-title`}>{subTitle}</h1>
          )}

          <div className="ModalWarning__message">
            {this.props.message}
          </div>
        </section>
        {this.props.type === "unsaved" && (
          <section className="ModalWarning__section ModalWarning__section--checkbox-choice">
            <Checkbox
              className="ModalWarning__checkbox"
              label="Remember My Choice"
              checked={this.state.checked}
              handleToggle={this.handleCheckboxToggle}
            />
          </section>
        )}
        {shouldRenderReferences && (
          <div className="ModalWarning__content">
            <div
              className="ModalWarning__content__inner"
              onScroll={this.handleScroll.bind(this)}
            >
              {this.renderReferences(
                hasFallbackReferences,
                hasQuickReplyReferences,
                hasRedirectReferences
              )}
              {hasResponseScheduleReferences && this.renderScheduleReferences()}
            </div>
            <div
              className={classNames("ModalWarning__content__gradient", {
                "ModalWarning__content__gradient--show-gradient": (
                  this.props.totalReferenceButtons > maxNumberOfReferenceButtons &&
                  !this.state.scrolledToBottom
                )
              })}
            />
          </div>
        )}
        <div className="ModalWarning__button-group">
          {this.renderActionButtons()}
        </div>
      </div>
    );
  }
}

ModalWarning.isSmall = true;

ModalWarning.propTypes = {
  /** The type of ModalWarning */
  type: PropTypes.string,
  /** Title of the ModalWarning */
  title: PropTypes.string.isRequired,
  /** Sub-title of ModalWarning */
  message: PropTypes.string.isRequired,
  /** Buttons to be rendered at bottom of ModalWarning */
  buttons: PropTypes.oneOfType([
    PropTypes.array, ImmutablePropTypes.set
  ]),
  /** Answer tags */
  tags: ImmutablePropTypes.list.isRequired,
  /** The current response */
  response: ImmutablePropTypes.record,
  /** All responses where the current response is referenced as a fallback */
  responseFallbackReferenceResponses: ImmutablePropTypes.list,
  /** All responses where the current response is referenced as a quick reply */
  responseQuickReplyReferenceResponses: ImmutablePropTypes.list,
  /** All responses where the current response is referenced as a quick reply */
  responseAnswersRedirectReferencesResponses: ImmutablePropTypes.list,
  /** Function to change the page */
  setPage: PropTypes.func.isRequired,
  /** Action creator for deleting a schedule */
  deleteSchedule: PropTypes.func.isRequired,
  /** Action creator for saving (PATCH or POST) the current response */
  saveResponse: PropTypes.func.isRequired,
  /** Action creator for updating the current response locally */
  updateResponse: PropTypes.func.isRequired,
  /** Action creator for deleting the current response */
  deleteResponse: PropTypes.func.isRequired,
  /** Action creator for toggling the live status on and off */
  toggleResponseStatus: PropTypes.func.isRequired,
  /** Action to delete variable */
  setDropdownVariableAction: PropTypes.func.isRequired,
  /** The variable to delete */
  variable: ImmutablePropTypes.record,
  newVariable: ImmutablePropTypes.record,
  variableListIndex: PropTypes.number,
  messageIndex: PropTypes.number,
  keyPath: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  ),
  /** Actions will be rendered as buttons at the bottom of the modal */
  actions: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    buttonTint: PropTypes.string,
    onClick: PropTypes.func
  })),
  deleteTraining: PropTypes.func,
  expression: ImmutablePropTypes.map,
  expressionPairIndex: PropTypes.number,
  expressionIndex: PropTypes.number
};

ModalWarning.defaultProps = {
  actions: [],
  variable: null,
  messageIndex: null,
  keyPath: null,
  newVariable: null,
  variableListIndex: null,
  deleteTraining: null,
  expression: null,
  expressionIndex: null,
  expressionPairIndex: null
};

function mapState(state, ownProps) {
  const { tags, responses } = state;

  return {
    tags,
    response: ownProps.responseSnapshot
      ? responses.find(response => response.id === ownProps.responseSnapshot.id)
      : null,
    responseFallbackReferenceResponses: ownProps.responseFallbackReferences
      ? responses.filter(response => (
        Object.keys(ownProps.responseFallbackReferences).includes(response.id)
      ))
      : Immutable.List(),
    responseQuickReplyReferenceResponses: ownProps.responseQuickReplyReferences
      ? responses.filter(response => Object.keys(ownProps.responseQuickReplyReferences).includes(
        response.id
      ))
      : Immutable.List(),
    responseAnswersRedirectReferencesResponses: ownProps.responseAnswersRedirectReferences
      ? responses.filter(response => (
        Object.keys(ownProps.responseAnswersRedirectReferences).includes(response.id)
      ))
      : Immutable.List()
  };
}

function mapDispatch(dispatch) {
  return {
    setPage: bindActionCreators(setPage, dispatch),
    closeModal: bindActionCreators(closeModalAction, dispatch),
    deleteSchedule: bindActionCreators(deleteSchedule, dispatch),
    saveResponse: bindActionCreators(saveResponse, dispatch),
    updateResponse: bindActionCreators(updateResponse, dispatch),
    deleteResponse: bindActionCreators(deleteResponse, dispatch),
    toggleResponseStatus: bindActionCreators(toggleResponseStatus, dispatch),
    setDropdownVariableAction: bindActionCreators(setDropdownVariable, dispatch)
  };
}

const Connector = connect(
  mapState,
  mapDispatch
)(ModalWarning);

export default Connector;
